module.exports = __webpack_public_path__ + "media/src/Shared/Assets/roamly/camper_login-1f51d1f8c7d27b8db971d1bc99c0727b36a51464a99a0ec3a11955d4cae79fab.jpg";